import { toString } from 'lodash-es';

export function toIsoInstant(value: unknown): string | undefined {
  if (!value) {
    return undefined;
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? undefined : value.toISOString();
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const parsedDate = new Date(value);

    return Number.isNaN(parsedDate.getTime()) ? undefined : parsedDate.toISOString();
  }

  return undefined;
}
export function toIsoInstantOrEmptyString(value: unknown): string {
  return toIsoInstant(value) ?? '';
}

export function toIsoStringIfDate(input?: Date | string): string {
  return toIsoInstant(input) ?? toString(input);
}
